import { render, staticRenderFns } from "./ClientPortfolioSelectClients.vue?vue&type=template&id=2e2ab7f9"
import script from "./ClientPortfolioSelectClients.vue?vue&type=script&lang=js"
export * from "./ClientPortfolioSelectClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports